





















































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { ModuleOption, InformationCodes } from '@/data/enums'
import OptionModule from '@/components/OptionModule.vue'
import ToggleButton from '@/components/ui/ToggleButton.vue'
import '@/icons/glassthicknessminus-15.ts'
import '@/icons/glassthicknessminus-16.ts'
import '@/icons/glassthicknessminus-167.ts'
import '@/icons/glassthicknessminus-174.ts'
import '@/icons/glassthicknessplus-15.ts'
import '@/icons/glassthicknessplus-16.ts'
import '@/icons/glassthicknessplus-167.ts'
import '@/icons/glassthicknessplus-174.ts'
import '@/icons/glassthickness-minus.ts'
import '@/icons/glassthickness-plus.ts'
import GlassOptionValue from '@/data/glass-option-value'
import '@/icons/options-glassthickness'

@Component({
  components: {
    OptionModule,
    ToggleButton
  }
})
export default class ThicknessModule extends Vue {
  @Prop() private optionId!: ModuleOption
  private informationCode: string = InformationCodes.ModuleThickness
  private thickness: string = 'plus'

  private get showPrice (): boolean {
    return this.$store.state.data.optician.showPrices
  }

  private get optionIds (): ModuleOption[] {
    return [this.optionId]
  }

  private get priceTypeText () {
    return this.$store.state.data.optician.priceTypeText
  }

  private toggleOptionValue (optionValue: GlassOptionValue) {
    this.$store.dispatch('cart/toggleOptionValue', optionValue)
      .catch((err) => console.error(err))
  }
}
